import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const del = ({ commit }, item) => {
  commit(types.TERRITORY_DELETE_RESET)
  commit(types.TERRITORY_DELETE_TOGGLE_LOADING)

  return fetch(item['@id'], { method: 'DELETE' })
    .then(() => {
      commit(types.TERRITORY_DELETE_SET_DELETED, item)
    })
    .catch((e) => {
      commit(types.TERRITORY_DELETE_SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.TERRITORY_DELETE_TOGGLE_LOADING)
    })
}

export const reset = ({ commit }) => {
  commit(types.TERRITORY_DELETE_RESET)
}
